/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* -------------------------------------------------------------------------
 * MV - Placeholder animado del buscador del header (efecto maquina de escribir)
 *
 * Para cambiar los textos, editar el array FRASES.
 * Funciona en desktop Y en movil: antes de partir mide el ancho real del input
 * y descarta las frases que no alcanzan a caber (en un telefono muy angosto
 * quedan solo las cortas). Si cabe menos de 2 frases, no anima.
 * El placeholder que trae el buscador desde el editor de temas se muestra al
 * cargar y despues se borra: NO vuelve a aparecer en la rotacion.
 * Se detiene al hacer foco (o tap) en el input.
 * ------------------------------------------------------------------------- */
(function () {
  var FRASES = [
    'Buscas magnesio glicinato...',
    'Buscas colágeno hidrolizado...',
    'Buscas vitamina D3 + K2...',
    'Buscas omega 3...'
  ];

  var ESCRIBIR = 90;        // ms por letra al escribir
  var BORRAR = 45;          // ms por letra al borrar
  var PAUSA_LLENO = 2200;   // pausa con la frase completa
  var PAUSA_VACIO = 400;    // pausa despues de borrar
  var ESPERA_INICIAL = 1800;

  // Deja solo las frases que caben en el ancho real del input (clave en movil)
  function frasesQueCaben(input, frases) {
    var cs = window.getComputedStyle(input);
    var ancho = input.getBoundingClientRect().width - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
    if (!ancho || !window.HTMLCanvasElement) return frases;
    var ctx = document.createElement('canvas').getContext('2d');
    if (!ctx) return frases;
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    return frases.filter(function (f) { return ctx.measureText(f).width <= ancho; });
  }

  function iniciar() {
    var input = document.querySelector('input[name="q"].search-bar__input') || document.querySelector('input[name="q"]');
    if (!input) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var frases = frasesQueCaben(input, FRASES);
    if (frases.length < 2) return;   // con 1 sola frase no tiene sentido animar

    var base = input.placeholder || frases[0];
    var activo = true;

    input.addEventListener('focus', function () {
      activo = false;
      input.placeholder = base;
    }, { once: true });

    var dormir = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

    // cuantas letras iniciales comparten dos frases (para no borrar de mas)
    var prefijo = function (a, b) {
      var n = 0;
      while (n < a.length && n < b.length && a[n] === b[n]) n++;
      return n >= 3 ? n : 0;
    };

    (async function () {
      await dormir(ESPERA_INICIAL);
      var i = 0;
      while (activo) {
        var actual = input.placeholder;      // lo que se ve ahora (1a vuelta: el placeholder del tema)
        var sig = frases[i];
        var corte = prefijo(actual, sig);

        for (var n = actual.length; n > corte && activo; n--) {
          input.placeholder = actual.slice(0, n - 1);
          await dormir(BORRAR);
        }
        if (!activo) break;
        await dormir(PAUSA_VACIO);

        for (var m = corte; m <= sig.length && activo; m++) {
          input.placeholder = sig.slice(0, m);
          await dormir(ESCRIBIR);
        }
        if (!activo) break;
        await dormir(PAUSA_LLENO);

        i = (i + 1) % frases.length;
      }
    })();
  }

  // Esperamos a que carguen las fuentes: si no, la medicion usa la tipografia
  // de reemplazo y da un ancho equivocado.
  function arrancar() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(iniciar).catch(iniciar);
    } else {
      iniciar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
